import Masonry from 'masonry-layout';
import Debounce from "@wwdev/bootstrap/Debounce";

class MasonryComponent {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-grid="scope"]',
			item: '[data-grid="item"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let settings = Object.assign({
				itemSelector: this.config.item,
				percentPosition: true
			}, $(scope).data())

			const masonry = new Masonry(scope, settings);
			//this.observeItems(scope, masonry);
		})
	}

	observeItems(scope, masonry) {
		const relayout = () => {
			Debounce.debounce("masonry_layout", () => {
				masonry.layout();
			}, 200)
		};

		const observer = new ResizeObserver(relayout);

		scope.querySelectorAll(this.config.item).forEach((item) => {
			observer.observe(item);
		});
	}
}

export default MasonryComponent;